<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 19 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.25 5V15C1.25 17.2091 4.83172 19 9.25 19C13.6683 19 17.25 17.2091 17.25 15V5M1.25 5C1.25 7.20914 4.83172 9 9.25 9C13.6683 9 17.25 7.20914 17.25 5M1.25 5C1.25 2.79086 4.83172 1 9.25 1C13.6683 1 17.25 2.79086 17.25 5M17.25 10C17.25 12.2091 13.6683 14 9.25 14C4.83172 14 1.25 12.2091 1.25 10"
      :stroke="color"
      :stroke-width="strokeWidth"
    />
  </svg>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
  width: {
    type: [String, Number],
    default: "19",
  },
  height: {
    type: [String, Number],
    default: "20",
  },
  color: {
    type: String,
    default: "#003D6A",
  },
  strokeWidth: {
    type: [String, Number],
    default: "2",
  },
});
</script>
